export const propertyData = {
  id: '10280192',
  title: 'The Hayloft - Rural tranquility 15 mins to Gatwick',
  propertyType: 'Entire loft',
  location: 'Balcombe, West Sussex, United Kingdom',
  rating: 4.99,
  reviewCount: 216,
  isGuestFavourite: true,
  isSuperHost: false,
  
  capacity: {
    guests: 4,
    bedrooms: 1,
    beds: 2,
    bathrooms: 1.5
  },
  
  images: [
    'https://customer-assets.emergentagent.com/job_9544cd72-880c-4b9a-8267-d374355af943/artifacts/5cw4dx81_da19caa7-0b88-4a43-b30e-e0f78cafca63.jpg.avif',
    'https://customer-assets.emergentagent.com/job_9544cd72-880c-4b9a-8267-d374355af943/artifacts/wtdccono_5cedf447-8ad3-41c0-8c86-6d5ce2e60f2f.jpg.avif',
    'https://customer-assets.emergentagent.com/job_9544cd72-880c-4b9a-8267-d374355af943/artifacts/fgprykvg_0df6c52c-cba0-47d1-b8bc-2eca44947c80.jpg.avif',
    'https://customer-assets.emergentagent.com/job_9544cd72-880c-4b9a-8267-d374355af943/artifacts/jn6bpwzh_0f1cc964-f55f-46d4-b6f8-559439a2a9f9.jpg.avif',
    'https://customer-assets.emergentagent.com/job_9544cd72-880c-4b9a-8267-d374355af943/artifacts/i5bu1br9_3b605384-ad8d-4f2d-937e-925d74181953.jpg.avif',
    'https://customer-assets.emergentagent.com/job_9544cd72-880c-4b9a-8267-d374355af943/artifacts/mydscwev_1c23c963-3ed0-4e13-b1b6-d0877ad340c7.jpeg.avif',
    'https://customer-assets.emergentagent.com/job_9544cd72-880c-4b9a-8267-d374355af943/artifacts/uh98za22_2c87e8ac-ff47-4e68-b79d-44b2f9847064.jpg.avif',
    'https://customer-assets.emergentagent.com/job_9544cd72-880c-4b9a-8267-d374355af943/artifacts/w7ldeiu3_04ff1cb3-bd43-4f0a-b58b-9fc5754feecc.jpg.avif',
    'https://customer-assets.emergentagent.com/job_9544cd72-880c-4b9a-8267-d374355af943/artifacts/qwua3f15_31bd15b8-f29e-4c0d-b288-0e3c0f5dd38a.jpg.avif',
    'https://customer-assets.emergentagent.com/job_9544cd72-880c-4b9a-8267-d374355af943/artifacts/xwgobozk_8a27fc7a-be61-44f0-b9a2-9cb97c833b1a.jpg.avif',
    'https://customer-assets.emergentagent.com/job_9544cd72-880c-4b9a-8267-d374355af943/artifacts/l8qlqxpp_9c1a3f12-c32e-445d-9e3f-dc0c7f392273.jpg.avif',
    'https://customer-assets.emergentagent.com/job_9544cd72-880c-4b9a-8267-d374355af943/artifacts/8ujo1599_15f47636-9e1c-45a3-932c-c8d22f606f99.jpg.avif',
    'https://customer-assets.emergentagent.com/job_9544cd72-880c-4b9a-8267-d374355af943/artifacts/svsofwq2_6f014dc8-0bc5-4c1c-8edf-a7abe7820343.jpg.avif',
    'https://customer-assets.emergentagent.com/job_9544cd72-880c-4b9a-8267-d374355af943/artifacts/76ivo4eg_50c00c5f-9385-4ce5-affb-51bff74ff420.jpg.avif',
    'https://customer-assets.emergentagent.com/job_9544cd72-880c-4b9a-8267-d374355af943/artifacts/qj745mfr_84a8b988-1112-4cc9-b8aa-a833323c5593.jpg.avif',
    'https://customer-assets.emergentagent.com/job_9544cd72-880c-4b9a-8267-d374355af943/artifacts/3nref08f_88b56dae-f22d-4879-8146-619a799c966a.jpeg.avif',
    'https://customer-assets.emergentagent.com/job_9544cd72-880c-4b9a-8267-d374355af943/artifacts/d45a41wv_70e8191f-1b76-4093-a8bf-a7d07f525b10.jpg.webp',
    'https://customer-assets.emergentagent.com/job_9544cd72-880c-4b9a-8267-d374355af943/artifacts/wch6h3wl_440a7b10-1981-42ca-b956-5ab1d4c7d658.jpg.avif',
    'https://customer-assets.emergentagent.com/job_9544cd72-880c-4b9a-8267-d374355af943/artifacts/le51ypk0_593f6c4a-66ac-40b7-a0ec-9dce5532dd20.jpg.avif',
    'https://customer-assets.emergentagent.com/job_9544cd72-880c-4b9a-8267-d374355af943/artifacts/qope9pyi_6709ac65-29e9-49e1-ba1c-dee4e093b12f.jpg.avif',
    'https://customer-assets.emergentagent.com/job_9544cd72-880c-4b9a-8267-d374355af943/artifacts/1pq2r28i_99513ab8-469f-448c-b720-378d13849092.jpg.avif',
    'https://customer-assets.emergentagent.com/job_9544cd72-880c-4b9a-8267-d374355af943/artifacts/pb1w4008_88dfbc8b-e207-4407-9aac-57fc53f15551.jpg.avif',
    'https://customer-assets.emergentagent.com/job_9544cd72-880c-4b9a-8267-d374355af943/artifacts/xpwtnrrc_98a51753-f4ce-407b-8e64-6f3b88b63a66.jpg.avif',
    'https://customer-assets.emergentagent.com/job_9544cd72-880c-4b9a-8267-d374355af943/artifacts/2x0121qo_00612500-cc10-4554-b47d-1c1620dec3f8.jpg.avif',
    'https://customer-assets.emergentagent.com/job_9544cd72-880c-4b9a-8267-d374355af943/artifacts/rywuq04q_2107793d-d772-4e95-9c89-a39320a70316.jpeg.avif',
    'https://customer-assets.emergentagent.com/job_9544cd72-880c-4b9a-8267-d374355af943/artifacts/s02h3z46_21428173-feed-491e-9172-7815fa79cae0.jpg.avif',
    'https://customer-assets.emergentagent.com/job_9544cd72-880c-4b9a-8267-d374355af943/artifacts/1hzge3n4_b7b40137-b012-4125-a386-2f2322ae9403.jpg.avif',
    'https://customer-assets.emergentagent.com/job_9544cd72-880c-4b9a-8267-d374355af943/artifacts/0anjw9z5_b68cfe5f-5116-49ae-ad9b-d5fef8b896a6.jpg-2.avif',
    'https://customer-assets.emergentagent.com/job_9544cd72-880c-4b9a-8267-d374355af943/artifacts/v17cay81_dc51beff-a29f-44cc-b93e-637815b018ed.jpg.avif',
    'https://customer-assets.emergentagent.com/job_9544cd72-880c-4b9a-8267-d374355af943/artifacts/aeazwjbs_e46d107f-9f71-4cfe-8844-f47af62e196e.jpg.avif',
    'https://customer-assets.emergentagent.com/job_9544cd72-880c-4b9a-8267-d374355af943/artifacts/mybymk2z_be008ed6-103d-4817-98d6-8cdd19328ca1.jpg.avif',
    'https://customer-assets.emergentagent.com/job_9544cd72-880c-4b9a-8267-d374355af943/artifacts/4ixkujbo_d63ae56f-354c-4485-9117-725f41aebf9d.jpg.avif',
    'https://customer-assets.emergentagent.com/job_9544cd72-880c-4b9a-8267-d374355af943/artifacts/24eeyciv_d79528b6-4321-4a41-b3e4-8e7349c2c78c.jpg.avif',
    'https://customer-assets.emergentagent.com/job_9544cd72-880c-4b9a-8267-d374355af943/artifacts/6meeys9q_e89ed61f-dbd2-4b94-a312-c152426392b4.jpg.avif',
    'https://customer-assets.emergentagent.com/job_9544cd72-880c-4b9a-8267-d374355af943/artifacts/ebvaqr7j_f6ea352b-ef24-4db6-a1a6-9e854b8e4f4a.jpeg.avif',
    'https://customer-assets.emergentagent.com/job_9544cd72-880c-4b9a-8267-d374355af943/artifacts/kcogmn7n_f158ab71-b5b9-4da3-ae7e-0aae88689d92.jpg.avif',
    'https://customer-assets.emergentagent.com/job_9544cd72-880c-4b9a-8267-d374355af943/artifacts/bultj82x_f991e777-3e6e-4513-9425-fca71470ba48.jpg.avif'
  ],
  floorplan: 'https://customer-assets.emergentagent.com/job_9544cd72-880c-4b9a-8267-d374355af943/artifacts/5merbd4v_51daa0cb-d2a3-4f6d-81ec-c7513e28b325.jpg.avif',
  
  host: {
    name: 'Susanna',
    yearsHosting: 10,
    profileImage: 'https://i.pravatar.cc/300?img=47',
    responseRate: '100%',
    responseTime: 'within a few hours',
    location: 'Balcombe, United Kingdom',
    bio: 'Wife, mother and Personal Organiser!'
  },
  
  highlights: [
    {
      title: 'Top 5% of homes',
      description: 'This home is highly ranked based on ratings, reviews and reliability.'
    },
    {
      title: '24-hour self check-in',
      description: 'Check yourself in with the keypad whenever you arrive.'
    },
    {
      title: 'Unbeatable location',
      description: '100% of guests in the past year gave this location a 5-star rating.'
    }
  ],
  
  description: `Rural bliss yet only 15 mins drive from GWK. Superking bed in a dbl aspect rm, sitting rm, kitchen & bathroom in spacious, private apartment. The sitting rm has an L-shaped sofabed and is ensuite to the bathroom so works as a bed rm for close friends or family of those in the main bedroom! The Loft is beautifully furnished, peaceful and has stunning views, its own front door, secure parking, WIFI, acres of garden and loads of local delights to explore from Brighton beach to our village pub!`,
  
  fullDescription: `The Hayloft is newly renovated and freshly painted with new kitchen and bathroom. Wooden floors throughout so you know for sure that it is spotlessly clean! The bedroom has far reaching views, a super king size bed with crisp, white linen, Smart TV, desk and chaise longue. The sitting room (which is ensuite to the bathroom) has a sofa bed with crisp white linen, fold out table with 2 chairs and Smart TV. Bathroom with bath and shower, luxury towels and toiletries. The kitchen is equipped with a hob, oven, microwave, dishwasher, washing machine, kettle, Nespresso coffee machine, toaster, fridge (with icebox) and breakfast bar for two for you to prepare your own drinks and breakfast. The Hayloft is perfect for two people and cosy for four, who are ideally close friends or family members, as the sitting room/sofa bed is ensuite to the bathroom.`,
  
  sleepingArrangements: [
    {
      room: 'Bedroom',
      bedType: '1 king bed',
      image: 'https://a0.muscache.com/im/pictures/6709ac65-29e9-49e1-ba1c-dee4e093b12f.jpg?im_w=720'
    },
    {
      room: 'Living room',
      bedType: '1 sofa bed',
      image: 'https://a0.muscache.com/im/pictures/dc51beff-a29f-44cc-b93e-637815b018ed.jpg?im_w=720'
    }
  ],
  
  amenities: [
    { name: 'Kitchen', available: true },
    { name: 'Wifi', available: true },
    { name: 'Dedicated workspace', available: true },
    { name: 'Free parking on premises', available: true },
    { name: 'TV', available: true },
    { name: 'Washing machine', available: true },
    { name: 'Bath', available: true },
    { name: 'Private back garden – Not fully fenced', available: true },
    { name: 'Luggage drop-off allowed', available: true },
    { name: 'Travel cot', available: true },
    { name: 'Shower', available: true },
    { name: 'Dishwasher', available: true },
    { name: 'Microwave', available: true },
    { name: 'Coffee maker', available: true },
    { name: 'Oven', available: true },
    { name: 'Smart TV', available: true },
    { name: 'Heating', available: true },
    { name: 'Hair dryer', available: true },
    { name: 'Iron', available: true },
    { name: 'Essentials', available: true },
    { name: 'Hangers', available: true },
    { name: 'Bed linens', available: true },
    { name: 'Extra pillows and blankets', available: true },
    { name: 'Ethernet connection', available: true },
    { name: 'Desk', available: true }
  ],
  
  pricing: {
    nightlyRate: 98,
    cleaningFee: 40,
    serviceFee: 52,
    currency: '£'
  },
  
  checkIn: '2026-03-08',
  checkOut: '2026-03-11',
  
  reviews: [
    {
      id: 1,
      userName: 'Karen',
      userImage: '/images/karen-pfp.webp',
      rating: 5,
      date: '1 week ago',
      yearsOnAirbnb: 2,
      comment: "Susanna was friendly, very responsive and welcoming, Beautiful location, very peaceful. The loft was very clean and presented lovely we weren't there for a holiday but I can imagine the walks would be wonderful 😊"
    },
    {
      id: 2,
      userName: 'Mary',
      userImage: '/images/mary-pfp.webp',
      rating: 5,
      date: 'July 2025',
      yearsOnAirbnb: 7,
      comment: "We had a lovely stay at the Hayloft. Everything was so well thought out and organised. It was very clean and you could tell Susanna takes great care of the property. Susanna herself was an amazing host and made sure we had everything we could possibly need. The setting was perfect and picturesque. It was just what we needed for a weekend escape from the city. We would definitely stay again and have already told our friends about it."
    },
    {
      id: 3,
      userName: 'David',
      userImage: '/images/david-pfp.webp',
      rating: 5,
      date: 'April 2025',
      yearsOnAirbnb: 9,
      comment: "Thank you for the use of your property, it was just right as our base, whilst attending an event at the K2. Everything was spick and span, with all that we needed on hand for our stay."
    },
    {
      id: 4,
      userName: 'Alasdair',
      userImage: '/images/alasdair-pfp.webp',
      rating: 5,
      date: 'March 2025',
      location: 'Olympic Valley, California',
      yearsOnAirbnb: 3,
      comment: "A wonderful, private home in rural West Sussex - country lane access to the local villages and a short drive from the town of Horsham. Very near to the English garden at Nymans, Handcross. The accommodation itself is a fully self-contained loft that has been converted into an apartment with a large bedroom facing East, a living room, a bathroom and shower, and spacious kitchen with modern appliances. There is plenty of room for parking on the property. Susanna is a very helpful, friendly, and accommodating host. I enjoyed my stay at the 'Hayloft' immensely - and would gladly visit again, in the future…"
    },
    {
      id: 5,
      userName: 'Jan',
      userImage: 'https://i.pravatar.cc/150?img=20',
      rating: 5,
      date: 'July 2025',
      yearsOnAirbnb: 4,
      comment: "We have enjoyed a wonderful six day break at The Hayloft. Susanna is the most perfect Super Fabulous Host, offering a very friendly warm welcome, with advice on the local area and places to eat. The Hayloft has everything you need to enjoy a wonderful relaxing break, with a super comfortable bed and sofa bed and is beautifully and tastefully furnished throughout."
    },
    {
      id: 6,
      userName: 'Caroline',
      userImage: 'https://i.pravatar.cc/150?img=25',
      rating: 5,
      date: 'July 2025',
      yearsOnAirbnb: 10,
      comment: "We had a lovely stay in Susanna's hay loft, our host was absolutely fantastic in helping us get around and giving us information about our location. Thank you Susanna."
    }
  ],
  
  ratingBreakdown: {
    cleanliness: 5.0,
    accuracy: 5.0,
    checkIn: 5.0,
    communication: 5.0,
    location: 5.0,
    value: 4.9
  },
  
  houseRules: {
    checkInTime: '15:00',
    checkOutTime: '11:00',
    maxGuests: 4,
    cancellationPolicy: 'Free cancellation before 15:00 on 7 March. Cancel before check-in on 8 March for a partial refund.'
  },
  
  safetyFeatures: [
    'Nearby lake, river, other body of water',
    'Carbon monoxide alarm',
    'Smoke alarm'
  ]
};